import { observer } from "mobx-react";
import { h } from "preact";
import { useEffect } from "preact/hooks";
import { Tracking, } from "restaumatic-client";
import Alert from "./Alert";
function FreeDeliveryWithAddressStickyAlert(props) {
    const { freeDeliveryWithAddressStickyAlert } = props;
    const { isVisible, textMessage, freeDeliveryPrice } = freeDeliveryWithAddressStickyAlert;
    // Track the event when the alert is shown
    useEffect(() => {
        var _a;
        if (isVisible) {
            Tracking.trackEvent({
                tag: "FreeDeliveryToastShown",
                contents: {
                    price: (_a = freeDeliveryPrice === null || freeDeliveryPrice === void 0 ? void 0 : freeDeliveryPrice.asNumber) !== null && _a !== void 0 ? _a : -1,
                },
            });
        }
    }, [isVisible, freeDeliveryPrice]);
    const handleClose = () => {
        var _a;
        freeDeliveryWithAddressStickyAlert.markAsClosed();
        Tracking.trackEvent({
            tag: "FreeDeliveryToastClosed",
            contents: {
                price: (_a = freeDeliveryPrice === null || freeDeliveryPrice === void 0 ? void 0 : freeDeliveryPrice.asNumber) !== null && _a !== void 0 ? _a : -1,
            },
        });
    };
    if (!isVisible || textMessage === null) {
        return null;
    }
    return (h(Alert, { type: "info", variant: "toast", message: textMessage, onClose: handleClose }));
}
export default observer(FreeDeliveryWithAddressStickyAlert);
